var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.84534 3.50001C9.74943 3.49941 9.65527 3.5257 9.57355 3.57589C9.49182 3.62609 9.42579 3.69817 9.38296 3.78399L7.6203 7.30929L3.43484 7.95341C3.34115 7.96789 3.25331 8.00803 3.18104 8.06939C3.10878 8.13074 3.05492 8.21092 3.02544 8.30101C2.99597 8.39111 2.99202 8.48761 3.01404 8.57982C3.03606 8.67202 3.08319 8.75633 3.1502 8.82338L6.04541 11.7186L5.40062 15.9087C5.38619 16.0025 5.39803 16.0984 5.43481 16.1858C5.4716 16.2732 5.53189 16.3488 5.609 16.404C5.6861 16.4592 5.77701 16.492 5.87162 16.4987C5.96623 16.5054 6.06085 16.4858 6.14497 16.4419L9.84199 14.5129L13.539 16.4419C13.6231 16.4858 13.7178 16.5054 13.8124 16.4987C13.907 16.492 13.9979 16.4592 14.075 16.404C14.1521 16.3488 14.2124 16.2732 14.2492 16.1858C14.286 16.0984 14.2978 16.0025 14.2834 15.9087L13.6386 11.7186L16.5338 8.82338C16.6008 8.75633 16.6479 8.67202 16.67 8.57982C16.692 8.48761 16.688 8.39111 16.6585 8.30101C16.6291 8.21092 16.5752 8.13074 16.5029 8.06939C16.4307 8.00803 16.3428 7.96789 16.2492 7.95341L12.0637 7.30929L10.301 3.78399C10.2587 3.69919 10.1937 3.62777 10.1133 3.57765C10.0329 3.52752 9.94011 3.50065 9.84534 3.50001Z",
    fill: "#1671B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a9e75bdcd84049750d40208c243931eb.svg";
export { ForwardRef as ReactComponent };